<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    props: {
        selected: {
            type: Boolean,
            default: false,
        },
        identifier: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            default: "No title",
        },
        circular: {
            type: Boolean,
            default: false,
        },
        primary: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["click"],
    data: () => ({
        clicked: false,
    }),
    computed: {},
    methods: {
        onClick() {
            // if (this.disabled) return
            this.$emit("click");
        },
    },
});
</script>

<template>
    <button class="selectable-button flex flex--valign-c flex--halign-c" :class="{ selected, primary, circular }" @click.stop="onClick">
        <div v-if="identifier" class="icon">{{ identifier }}</div>

        <span class="text text--size-20 text--semi-bold text--less-gap" :class="{ 'text--color-white text--shadow': selected, 'text--primary-b': !selected }">{{ title }}</span>

        <div v-if="!!$slots.absoluteContent" class="absolute-content">
            <slot name="absoluteContent"></slot>
        </div>
    </button>
</template>

<style lang="scss" scoped>
.selectable-button {
    position: relative;
    padding: rem(15) rem(30);
    border-radius: rem(8);
    height: rem(65);
    pointer-events: all;
    cursor: pointer;

    border: none;

    background-color: $color-accent-light-a;
    transition: background-color 0.05s ease-in-out;

    &.circular {
        height: rem(40);
        border-radius: rem(50);
    }

    &:hover {
        background-color: $color-accent-light-b;
        :deep(.help-button) {
            border-color: $color-accent-light-b;
        }
    }

    &.selected {
        background-image: $secondary-gradient;
        // :deep(.help-button) {
        //     border-color: $color-secondary-a;
        // }

        &.primary {
            background-image: $primary-gradient;

            &:hover {
                background-image: $primary-gradient-lighter;
            }
        }

        &:hover {
            background-image: $secondary-gradient-darker;
            // :deep(.help-button) {
            //     border-color: $color-secondary-a-darker;
            // }
        }
    }

    .absolute-content {
        position: absolute;
        top: rem(-10);
        right: rem(-10);
    }
}

@include media-breakpoint-down(lg) {
    .selectable-button {
        height: rem(60);
    }
}
@include media-breakpoint-down(md) {
    .selectable-button {
        height: rem(50);
    }
}
@include media-breakpoint-down(sm) {
    .selectable-button {
        height: rem(40);

        .absolute-content {
            top: 50%;
            right: rem(-35);
            transform: translateY(-50%);
        }
    }
}
</style>
